module.exports = __webpack_public_path__ + "static/media/NodBannerImage.cda21cb7.jpg";